import _ from 'lodash'
import updateCurriculumMutation from '../mutations/UpdateCurriculum.gql'
import fetchCurriculums from '../queries/FetchCurriculums.gql'

function normalize(variables) {
  return {
    ..._.omitBy(variables, _.isNil),
    steps: _.compact(
      variables.steps.map((e) => {
        const step = _.omitBy(e, _.isEmpty)
        return _.isEmpty(step) ? null : step
      })
    ),
  }
}

export default function (variables) {
  return {
    mutation: updateCurriculumMutation,
    variables: normalize(variables),
    refetchQueries: [
      {
        query: fetchCurriculums,
      },
    ],
  }
}
